import { QRCodeView } from 'src/views/menus/qrcode';

module.exports = Backbone.View.extend({
  isInitialized: false,

  render () {
    this.$el.html(`
      <div class="qrcode-app"></div>
    `);

    if (!INKIVE.C.IS_MOBILE_APP && !INKIVE.C.IS_MOBILE) {
      QRCodeView.mountApp();
    }

    this.isInitialized = true;
  },

  show () {
    if (!this.isInitialized) {
      this.render();
    }
  }
});
